if (!customElements.get('if-carousel')) {
  customElements.define('if-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.viewport = this.querySelector('.if-carousel__viewport');
      this.slides = [...this.track.children].filter(el => el.matches('[data-slide]'));
      this.mobile = matchMedia('(max-width:749px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.visible = true;
      const on = (el, type, fn) => el?.addEventListener(type, fn, {signal:this.abort.signal});
      on(this.querySelector('[data-prev]'),'click',()=>this.move(-1));
      on(this.querySelector('[data-next]'),'click',()=>this.move(1));
      on(this,'mouseenter',()=>{ this.hovered=true; this.autoplay(); });
      on(this,'mouseleave',()=>{ this.hovered=false; this.autoplay(); });
      on(this,'focusin',()=>{ this.focused=true; this.autoplay(); });
      on(this,'focusout',()=>queueMicrotask(()=>{ this.focused=this.contains(document.activeElement);this.autoplay(); }));
      on(this.track,'pointerdown',()=>{this.userPaused=true;this.autoplay();});
      on(this.track,'keydown',e=>{
        if(e.target!==this.track || this.dataset.enabled==='false')return;
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}
        if(e.key==='Home'||e.key==='End'){e.preventDefault();this.go(e.key==='Home'?0:this.positions.length-1);}
      });
      on(this.track,'scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());});
      on(document,'visibilitychange',()=>this.autoplay());
      on(document,'shopify:block:select',e=>{
        const index=this.slides.findIndex(slide=>slide.contains(e.target)||slide===e.target);
        if(index<0)return; this.userPaused=true;this.autoplay();
        this.track.scrollTo({left:this.targetFor(index),behavior:'instant'});
      });
      on(this.mobile,'change',()=>this.configure());
      on(this.reduced,'change',()=>this.configure());
      this.resize = new ResizeObserver(()=>{
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame=requestAnimationFrame(()=>this.configure());
      });
      this.resize.observe(this.track);this.slides.forEach(el=>this.resize.observe(el));
      this.intersection=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;this.autoplay();});
      this.intersection.observe(this);
      this.configure();
    }
    configure(){
      const prefix=this.mobile.matches?'mobile':'desktop';
      const allSlides=[...this.track.children].filter(el=>el.matches('[data-slide]'));
      allSlides.forEach(el=>el.hidden=Boolean(el.dataset.display && el.dataset.display!=='all' && el.dataset.display!==prefix));
      this.slides=allSlides.filter(el=>!el.hidden);
      this.cols=this.mobile.matches?1:Number(this.dataset.columns||3);
      this.step=this.mobile.matches?1:Number(this.dataset.step||1);
      this.dataset.enabled=this.dataset[prefix+'Enabled']||'true';
      this.dataset.adaptive=this.dataset[prefix+'Adaptive']||'false';
      this.dataset.dots=this.dataset[prefix+'Dots']||'bottom';
      this.dataset.arrows=this.dataset[prefix+'Arrows']||'bottom';
      this.style.setProperty('--if-cols',this.cols);
      this.style.setProperty('--if-peek',this.dataset[prefix+'Peek']==='true'?'24px':'0px');
      this.style.setProperty('--if-gap',(this.dataset[prefix+'Gap']||16)+'px');
      this.positions=[];
      const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
      for(let i=0;i<this.slides.length;i+=this.step){
        const pos=Math.min(max,this.targetFor(i));
        if(!this.positions.length||Math.abs(pos-this.positions.at(-1))>2)this.positions.push(pos);
      }
      if(max>0&&Math.abs(max-this.positions.at(-1))>2)this.positions.push(max);
      this.canMove=this.dataset.enabled!=='false'&&max>2;
      const dots=this.querySelector('[data-dots]');
      dots.hidden=!this.canMove||this.dataset.dots==='hidden';
      const signature=this.positions.join(',');
      if(signature!==this.dotSignature){
        this.dotSignature=signature;dots.replaceChildren();
        this.positions.forEach((_,i)=>{
          const dot=document.createElement('button');dot.type='button';dot.className='if-carousel__dot';
          dot.setAttribute('aria-label',`Ir al grupo ${i+1}`);dot.setAttribute('aria-controls',this.track.id);
          dot.addEventListener('click',()=>this.go(i),{signal:this.abort.signal});dots.append(dot);
        });
      }
      const arrowsHidden=!this.canMove||this.dataset.arrows==='hidden';
      this.querySelector('[data-prev]').hidden=arrowsHidden;this.querySelector('[data-next]').hidden=arrowsHidden;
      this.querySelector('.if-carousel__arrows').hidden=arrowsHidden;
      this.update();this.autoplay();
    }
    targetFor(index){
      const slide=this.slides[index];if(!slide)return 0;
      return this.track.scrollLeft+slide.getBoundingClientRect().left-this.track.getBoundingClientRect().left-parseFloat(getComputedStyle(this.track).paddingLeft||0);
    }
    update(){
      if(!this.positions?.length)return;
      this.index=this.positions.reduce((best,pos,i)=>Math.abs(pos-this.track.scrollLeft)<Math.abs(this.positions[best]-this.track.scrollLeft)?i:best,0);
      [...this.querySelector('[data-dots]').children].forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
      this.querySelector('[data-prev]').disabled=!this.canMove||(this.dataset.loop!=='true'&&this.index===0);
      this.querySelector('[data-next]').disabled=!this.canMove||(this.dataset.loop!=='true'&&this.index===this.positions.length-1);
      const status=this.querySelector('[data-status]');
      status.textContent=`Grupo ${this.index+1} de ${this.positions.length}`;
      if(this.dataset.adaptive==='true'&&this.dataset.enabled!=='false'){
        const box=this.track.getBoundingClientRect();
        const active=this.slides.filter(el=>{const r=el.getBoundingClientRect();return r.left<box.right-25&&r.right>box.left+25;});
        this.viewport.style.height=(Math.max(0,...active.map(el=>el.offsetHeight))+8)+'px';
      }else this.viewport.style.height='';
      const rect=this.track.getBoundingClientRect();
      this.slides.forEach(slide=>{
        const r=slide.getBoundingClientRect();
        const off=this.dataset.enabled!=='false'&&(r.right<=rect.left+2||r.left>=rect.right-2);
        slide.inert=off;slide.setAttribute('aria-hidden',String(off));
      });
    }
    go(index){
      if(!this.canMove)return;
      if(this.dataset.loop==='true')index=(index+this.positions.length)%this.positions.length;
      index=Math.max(0,Math.min(this.positions.length-1,index));
      this.track.scrollTo({left:this.positions[index],behavior:this.reduced.matches||this.dataset.effect==='fade'?'instant':'smooth'});
      if(this.dataset.effect==='fade'&&!this.reduced.matches){this.classList.remove('if-carousel--fading');void this.offsetWidth;this.classList.add('if-carousel--fading');}
      this.autoplay();
    }
    move(direction){this.go((this.index||0)+direction);}
    autoplay(){
      clearInterval(this.timer);
      if(!this.canMove||this.dataset.autoplay!=='true'||this.reduced.matches||this.userPaused||this.hovered||this.focused||document.hidden||!this.visible||window.Shopify?.designMode)return;
      this.timer=setInterval(()=>this.go(this.index>=this.positions.length-1?0:this.index+1),Math.max(2000,Number(this.dataset.speed||5)*1000));
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.intersection?.disconnect();clearInterval(this.timer);cancelAnimationFrame(this.frame);cancelAnimationFrame(this.resizeFrame);}
  });
}
